import './MonitoredObjects.scss';

import { CHANGE_EVENT_PREFERENCES } from '@sonar-software/sonar-ts-constants';
import { DataSecurityMonitoredObjects } from '@sonar-software/sonar-core';
import { DisabledAlert } from './DisabledAlert';
import { List } from 'antd';
import { LoadingSpinner } from '@ui/LoadingSpinner';
import { MonitoredObjectsButtons } from './MonitoredObjectsButtons';
import { NoObjectsAlert } from './NoObjectsAlert';
import React from 'react';
import { SonarText } from '@ui/text';

import { Else, If, Then, When } from 'react-if';

export interface MonitoredObjectsProps {
	onRefresh: () => void;
	isEnabled: boolean;
	loading: boolean;
	monitoredObjects?: DataSecurityMonitoredObjects | null;
	refreshing: boolean;
	salesforceUrl?: string;
}

export const MonitoredObjects: React.FC<MonitoredObjectsProps> = ({
	onRefresh,
	isEnabled,
	loading,
	monitoredObjects,
	refreshing,
	salesforceUrl
}) => {
	const renderItem = (item: string) => <List.Item>{ item }</List.Item>;
	const hasData = Boolean(monitoredObjects?.totalCount);
	const failed = !loading && !monitoredObjects;

	return (
		<div className='selected-objects'>
			<If condition={ loading }>
				<Then>
					<LoadingSpinner spinning={ loading } />
				</Then>
				<Else>
					<If condition={ isEnabled }>
						<Then>
							<If condition={ hasData }>
								<Then>
									<SonarText>{ CHANGE_EVENT_PREFERENCES.SELECTED_LIMITS }</SonarText>
									<MonitoredObjectsButtons
										onRefresh={ onRefresh }
										refreshing={ refreshing }
										salesforceUrl={ salesforceUrl } />
									<LoadingSpinner spinning={ refreshing }>
										<List
											dataSource={ monitoredObjects?.entityDefinitions }
											// eslint-disable-next-line max-len
											header={ CHANGE_EVENT_PREFERENCES.OBJECTS_MONITORED(monitoredObjects?.totalCount ?? 0) }
											itemLayout='vertical'
											renderItem={ renderItem }
											size='small' />
									</LoadingSpinner>
								</Then>
								<Else>
									<NoObjectsAlert
										failed={ failed }
										onRefresh={ onRefresh } />
									<When condition={ !failed }>
										<MonitoredObjectsButtons
											onRefresh={ onRefresh }
											refreshing={ refreshing }
											salesforceUrl={ salesforceUrl } />
									</When>
								</Else>
							</If>
						</Then>
						<Else>
							<DisabledAlert />
							<MonitoredObjectsButtons
								onRefresh={ onRefresh }
								refreshing={ refreshing }
								salesforceUrl={ salesforceUrl } />
						</Else>
					</If>
				</Else>
			</If>
		</div>
	);
};
